import { useState } from "react";

export type PaymentCardValidationInfo = {
  cardNumberComplete: boolean;
  expiredComplete: boolean;
  cvcComplete: boolean;
  cardNumberError: string;
  expiredError: string;
  cvcError: string;
};

const DEFAULT = {
  cardNumberComplete: false,
  expiredComplete: false,
  cvcComplete: false,
  cardNumberError: null,
  expiredError: null,
  cvcError: null,
};

export default function useCreditCardInputs() {
  const [paymentCardValidationInfo, setPaymentCardValidationInfo] =
    useState<PaymentCardValidationInfo>(DEFAULT);

  const [showPaymentCardEmptyFieldErrors, setShowPaymentCardEmptyFieldErrors] =
    useState(false);

  const {
    cardNumberError,
    expiredError,
    cvcError,
    cardNumberComplete,
    expiredComplete,
    cvcComplete,
  } = paymentCardValidationInfo;

  const isPaymentCardInfoValid =
    !cvcError &&
    !expiredError &&
    !cardNumberError &&
    cardNumberComplete &&
    expiredComplete &&
    cvcComplete;

  const onElementChange =
    (field: string, errorField: string) =>
    ({ complete, error = { message: null } }) => {
      setShowPaymentCardEmptyFieldErrors(false);
      setPaymentCardValidationInfo({
        ...paymentCardValidationInfo,
        [field]: complete,
        [errorField]: error.message,
      });
    };

  return {
    isPaymentCardInfoValid,
    paymentCardValidationInfo,
    setPaymentCardValidationInfo,
    showPaymentCardEmptyFieldErrors,
    setShowPaymentCardEmptyFieldErrors,
    onElementChange,
  };
}
